import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface AdminSectionProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  bodyClassName?: string;
  collapsed?: boolean;
  children: ReactNode;
}

/** Bordered card with a title row — the unit detail pages are composed of. */
export function AdminSection({
  title,
  description,
  actions,
  className,
  bodyClassName,
  collapsed = false,
  children,
}: AdminSectionProps) {
  return (
    <section className={cn('overflow-hidden rounded-xl border border-border bg-card/40', className)}>
      <div
        className={cn(
          'flex flex-wrap items-start justify-between gap-3 px-5 py-4',
          !collapsed && 'border-b border-border',
        )}
      >
        <div className="min-w-0 space-y-1">
          <h2 className="text-sm font-semibold tracking-tight text-foreground">{title}</h2>
          {description ? <p className="text-xs leading-5 text-muted-foreground">{description}</p> : null}
        </div>
        {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
      </div>
      {collapsed ? null : <div className={cn('p-5', bodyClassName)}>{children}</div>}
    </section>
  );
}
